import moment from 'moment';

export const dayKey = ({year, month, day}) => `${year}-${month}-${day}`;

const daysSpanned = (event) => {
    const firstDay = moment(event.get('startDate')).startOf('day');
    const lastDay = moment(event.get('endDate')).startOf('day');
    return Math.max(lastDay.diff(firstDay, 'days') + 1, 1);
};

// workHours is the total for the whole inspection, not for one block or one day, so it is spread
// evenly over every day of the inspection's blocks. Each card repeats that total, which is why the
// day totals can't simply add up the numbers shown on the cards. Only blocks passed in are counted:
// a block outside them leaves its hours on the blocks that are here.
export const scheduledHoursByDay = (immutableEvents) => {
    const events = immutableEvents.filter(event => event.get('workHours') && event.get('startDate'));

    const daysByInspection = {};
    events.forEach(event => {
        const inspectionId = event.get('inspection_id');
        daysByInspection[inspectionId] = (daysByInspection[inspectionId] || 0) + daysSpanned(event);
    });

    const hoursByDay = {};
    events.forEach(event => {
        const hoursPerDay = event.get('workHours') / daysByInspection[event.get('inspection_id')];
        const date = moment(event.get('startDate')).startOf('day');
        for(let i = daysSpanned(event); i > 0; i--) {
            const key = dayKey({year: date.year(), month: date.month(), day: date.date()});
            hoursByDay[key] = (hoursByDay[key] || 0) + hoursPerDay;
            date.add(1, 'day');
        }
    });

    return hoursByDay;
};

const roundHours = (hours) => Math.round(hours * 10) / 10;

export const formatHours = (hours) => `${roundHours(hours)} hrs`;

export const HOURS_RED = '#C62828';
export const HOURS_ORANGE = '#C75B00';
export const HOURS_GREEN = '#1B7F3B';
export const HOURS_BLUE = '#1565C0';

// Judged on the rounded figure so the color always agrees with the number on screen, and so a
// three-way split adding up to 23.999999 reads as 24.
export const hoursColor = (hours) => {
    const shown = roundHours(hours);
    if(shown < 20) return HOURS_RED;
    if(shown < 24) return HOURS_ORANGE;
    if(shown === 24) return HOURS_GREEN;
    return HOURS_BLUE;
};
